import { createWebHistory, createRouter } from 'vue-router'
import WelcomeLayout from '@/layouts/welcome.vue'
import DefaultLayout from '@/layouts/default.vue'

import HomeScreen from '@/pages/home-screen.vue'
import ModulesChoiceScreen from '@/pages/modules-choice.vue'
import QuizzScreen from '@/pages/quizz.vue'
import QuizzAwardsScreen from '@/pages/quizz-awards.vue'
import WebcastScreen from '@/pages/webcast.vue'
import PuzzleScreen from '@/pages/puzzle.vue'
import AuthMiddleware from '@/middleware/auth'

const routes = [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        component: ModulesChoiceScreen,
      },
    ],
  },
  {
    path: '/home',
    component: DefaultLayout,
    children: [
      {
        path: '',
        component: ModulesChoiceScreen,
      },
    ],
  },
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: 'modules-choice',
        component: ModulesChoiceScreen,
        // meta: {
        //   middleware: [AuthMiddleware],
        // },
      },
      {
        path: 'quizz',
        component: QuizzScreen,
        // meta: {
        //   middleware: [AuthMiddleware],
        // },
      },
      {
        path: 'quizz-awards',
        component: QuizzAwardsScreen,
        // meta: {
        //   middleware: [AuthMiddleware],
        // },
      },
      // {
      //   path: 'webcast',
      //   component: WebcastScreen,
      //   meta: {
      //     middleware: [AuthMiddleware],
      //   },
      // },
      {
        path: 'puzzle',
        component: PuzzleScreen,
        // meta: {
        //   middleware: [AuthMiddleware],
        // },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_PUBLIC_BASE_URL),
  routes,
})

// router.beforeEach((to, from, next) => {
//   if (to.meta && to.meta.middleware) {
//     return AuthMiddleware(to, from, next)
//   }
//   next()
// })

export default router
